// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#7e828b","menuActiveText":"#fff","subMenuActiveText":"#474d53","menuBg":"#fff","menuHover":"#eff4f9","subMenuBg":"#fff","subMenuHover":"#eff4f9","sideBarWidth":"228px"};